export default __webpack_public_path__ + "static/media/person_1.fdb06423.png";